"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForwardedDeviceProtocol = void 0;
const Exceptions_1 = require("../../../core/Exceptions");
const ButtplugDeviceProtocol_1 = require("../../../devices/ButtplugDeviceProtocol");
class ForwardedDeviceProtocol extends ButtplugDeviceProtocol_1.ButtplugDeviceProtocol {
    constructor(aDeviceImpl, _actualDeviceIndex, _messageSpecs, _clientSendClosure) {
        super(`${aDeviceImpl.Name}`, aDeviceImpl);
        this._actualDeviceIndex = _actualDeviceIndex;
        this._messageSpecs = _messageSpecs;
        this._clientSendClosure = _clientSendClosure;
        this.Initialize = () => __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
        // Override the base protocol ParseMessage, because we'll never actually handle our own messages.
        this.ParseMessage = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (!this.MessageSpecifications.hasOwnProperty(aMsg.Type.name)) {
                throw new Exceptions_1.ButtplugMessageException(`${this._name} cannot handle message of type ${aMsg.Type.name}`, aMsg.Id);
            }
            // Swap out the device index so we send to the correct device on the other end.
            aMsg.DeviceIndex = this._actualDeviceIndex;
            // We can forward this message on to the client to run.
            return yield this._clientSendClosure(aMsg);
        });
    }
    get MessageSpecifications() {
        return this._messageSpecs;
    }
}
exports.ForwardedDeviceProtocol = ForwardedDeviceProtocol;
//# sourceMappingURL=ForwardedDeviceProtocol.js.map